export const SPORT_HUB_MODULE_ID = 'sport-hub';
export const SPORT_HUB_LEAGUE_MODULE_ID = 'sport-hub-league';
export const SPORT_HUB_PRO_MODULE_ID = 'sport-hub-pro';
export const SPORT_HUB_PAY_MODULE_ID = 'sport-hub-pay';
export const SPORT_HUB_PAY_MOVEMENTS_PERMISSION = 'sport-hub-pay:movements';
export const SPORT_HUB_PAY_SHOP_PERMISSION = 'sport-hub-pay:shop';
export const SPORT_HUB_WEB_MODULE_ID = 'sport-hub-web';
export const SPORT_HUB_CLUB_MODULE_ID = 'sport-hub-club';
export const SPORT_HUB_BASE_STRUCTURES_LIMIT = 1;
export const SPORT_HUB_PRO_STRUCTURES_LIMIT = 2;

const normalizeModulesActived = (source) => {
  if (Array.isArray(source)) return source;
  if (source && Array.isArray(source.modulesActived)) return source.modulesActived;
  if (source && source.user && Array.isArray(source.user.modulesActived))
    return source.user.modulesActived;
  return [];
};

const isModuleEnabled = (moduleItem, moduleId) => {
  if (!moduleItem || !moduleId) return false;

  if (typeof moduleItem === 'string') {
    return moduleItem.trim() === moduleId;
  }

  if (typeof moduleItem !== 'object') return false;

  const moduleFromNestedObject =
    moduleItem.module && typeof moduleItem.module === 'object' ? moduleItem.module.id : null;
  const moduleCandidates = [moduleItem.moduleId, moduleItem.id, moduleFromNestedObject]
    .filter((item) => typeof item === 'string')
    .map((item) => item.trim())
    .filter(Boolean);

  if (!moduleCandidates.includes(moduleId)) return false;
  if (moduleItem.actived === false) return false;
  return true;
};

export const hasSportHubProModuleEnabled = (source) => {
  const modulesActived = normalizeModulesActived(source);
  return modulesActived.some((moduleItem) => isModuleEnabled(moduleItem, SPORT_HUB_PRO_MODULE_ID));
};

export const hasSportHubPayModuleEnabled = (source) => {
  const modulesActived = normalizeModulesActived(source);
  return modulesActived.some((moduleItem) => isModuleEnabled(moduleItem, SPORT_HUB_PAY_MODULE_ID));
};

const hasSportHubPayPermissionEnabled = (source, permission) => {
  if (!hasSportHubPayModuleEnabled(source)) return false;
  const user = source?.user && !Array.isArray(source.user) ? source.user : source;
  const isScopedUser = user?.sportHubAccess !== undefined && user?.sportHubAccess !== null;
  const permissions = user?.sportHubAccess?.permissions;
  if (isScopedUser) {
    return Array.isArray(permissions) && permissions.includes(permission);
  }
  return true;
};

export const hasSportHubMovementsPermissionEnabled = (source) =>
  hasSportHubPayPermissionEnabled(source, SPORT_HUB_PAY_MOVEMENTS_PERMISSION);

export const hasSportHubShopPermissionEnabled = (source) =>
  hasSportHubPayPermissionEnabled(source, SPORT_HUB_PAY_SHOP_PERMISSION);

export const hasSportHubWebModuleEnabled = (source) => {
  const modulesActived = normalizeModulesActived(source);
  return modulesActived.some((moduleItem) => isModuleEnabled(moduleItem, SPORT_HUB_WEB_MODULE_ID));
};

export const hasSportHubClubModuleEnabled = (source) => {
  const modulesActived = normalizeModulesActived(source);
  return modulesActived.some((moduleItem) => isModuleEnabled(moduleItem, SPORT_HUB_CLUB_MODULE_ID));
};

export const hasSportHubModuleEnabled = (source) => {
  const modulesActived = normalizeModulesActived(source);
  return modulesActived.some((moduleItem) => isModuleEnabled(moduleItem, SPORT_HUB_MODULE_ID));
};

export const hasSportHubLeagueModuleEnabled = (source) => {
  const modulesActived = normalizeModulesActived(source);
  return modulesActived.some((moduleItem) =>
    isModuleEnabled(moduleItem, SPORT_HUB_LEAGUE_MODULE_ID)
  );
};

export const resolveSportHubStructuresLimit = (source) =>
  hasSportHubProModuleEnabled(source)
    ? SPORT_HUB_PRO_STRUCTURES_LIMIT
    : SPORT_HUB_BASE_STRUCTURES_LIMIT;

export default {
  SPORT_HUB_MODULE_ID,
  SPORT_HUB_LEAGUE_MODULE_ID,
  SPORT_HUB_PRO_MODULE_ID,
  SPORT_HUB_PAY_MODULE_ID,
  SPORT_HUB_PAY_MOVEMENTS_PERMISSION,
  SPORT_HUB_PAY_SHOP_PERMISSION,
  SPORT_HUB_WEB_MODULE_ID,
  SPORT_HUB_CLUB_MODULE_ID,
  SPORT_HUB_BASE_STRUCTURES_LIMIT,
  SPORT_HUB_PRO_STRUCTURES_LIMIT,
  hasSportHubProModuleEnabled,
  hasSportHubPayModuleEnabled,
  hasSportHubMovementsPermissionEnabled,
  hasSportHubShopPermissionEnabled,
  hasSportHubWebModuleEnabled,
  hasSportHubClubModuleEnabled,
  hasSportHubModuleEnabled,
  hasSportHubLeagueModuleEnabled,
  resolveSportHubStructuresLimit,
};
